// extracted by mini-css-extract-plugin
export default {"checkout-summary":"SummaryStudents--checkout-summary--ywsXY","checkoutSummary":"SummaryStudents--checkout-summary--ywsXY"};